import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GroupInput } from '../../../../components/GroupInput/GroupInput';
import { START_TO_TYPE } from '../consts';
import { getServiceFilter, getServiceSelected } from '../../../store/selectors';
import { selectDirection, setBookingError } from '../../../store/serviceSlice';

export const DirectionSelector = ({ onSelect }) => {
    const { directions: selected = '' } = useSelector(getServiceSelected);
    const { directions: data = [] } = useSelector(getServiceFilter);
    const dispatch = useDispatch();

    const getMetadata = useCallback(() => {
        return data.map((item) => {
            const id = (item?.id ? item.id : item?.name);
            const code = (item?.code ? item?.code : item?.name);
            return {
                ...item,
                id,
                code,
            };
        });
    }, [data]);

    const onChangeHandler = (value) => {
        dispatch(setBookingError(''));
        if (onSelect) {
            if (onSelect(value)) {
                dispatch(selectDirection(value));
            }
        } else {
            dispatch(selectDirection(value));
        }
    };
    return <>
        <GroupInput
            type="selector"
            label="Направление"
            placeholder={START_TO_TYPE}
            value={selected}
            onChange={onChangeHandler}
            metaData={getMetadata()}
            onClear={() => onChangeHandler('')}
            id="direction"
        />
    </>;
};
